var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ImpactStoryIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 46,
    glyphHeight: 49,
    glyphOffsetY: -2
  }), React.createElement("path", {
    d: "M45.9566 3.04346H27.174V7.21737H45.9566V3.04346Z"
  }), React.createElement("path", {
    d: "M45.9566 11.3914H27.174V15.5653H45.9566V11.3914Z"
  }), React.createElement("path", {
    d: "M45.9566 19.7391H27.174V23.9131H45.9566V19.7391Z"
  }), React.createElement("path", {
    d: "M45.9565 28.0869H0.043457V32.2608H45.9565V28.0869Z"
  }), React.createElement("path", {
    d: "M45.9565 36.2261H0.043457V40.6087H45.9565V36.2261Z"
  }), React.createElement("path", {
    d: "M45.9565 44.7826H0.043457V48.9565H45.9565V44.7826Z"
  }), React.createElement("path", {
    d: "M12.5652 0.956543C5.67824 0.956543 0.043457 6.59133 0.043457 13.4783C0.043457 20.3652 5.67824 26 12.5652 26C19.4522 26 25.0869 20.3652 25.0869 13.4783C25.0869 6.59133 19.4522 0.956543 12.5652 0.956543ZM12.5652 21.8261C7.97389 21.8261 4.21737 18.0696 4.21737 13.4783C4.21737 8.88698 7.97389 5.13046 12.5652 5.13046C17.1565 5.13046 20.913 8.88698 20.913 13.4783C20.913 18.0696 17.1565 21.8261 12.5652 21.8261Z"
  }));
};
export var ImpactStoryIconGlyph = function (props) {
  return React.createElement(ImpactStoryIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};